export default __webpack_public_path__ + "static/media/Inter-Medium.d0a58d95.woff2";